var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"d-flex align-items-center justify-content-center btn btn-outline-primary btn-add font-weight-bolder",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" + ")])}
var staticRenderFns = []

export { render, staticRenderFns }